import type { FC } from 'react';

import { FacebookIcon, InstagramIcon, TiktokIcon, LinkedInIcon, TwitterIcon, YoutubeIcon } from '@eneco/sparky/icons';

const SocialMediaIcon: FC<{ iconName: string }> = ({ iconName }) => {
  const arrSocialBrands = ['facebook', 'instagram', 'linkedin', 'tiktok', 'twitter', 'youtube'];
  const strippedIconName = arrSocialBrands.reduce((socialBrand, strippedIconName) =>
    iconName.toLowerCase().includes(socialBrand) ? socialBrand : strippedIconName,
  );

  switch (strippedIconName) {
    case 'youtube':
      return <YoutubeIcon />;

    case 'linkedin':
      return <LinkedInIcon />;

    case 'twitter':
      return <TwitterIcon />;

    case 'instagram':
      return <InstagramIcon />;

    case 'tiktok':
      return <TiktokIcon />;

    case 'facebook':
    default:
      return <FacebookIcon />;
  }
};

export default SocialMediaIcon;
